import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CompetitiveDisclaimerService } from './competitive-disclaimer.service';

export function initServices(
  competitiveDisclaimerService: CompetitiveDisclaimerService
) {
  return () => competitiveDisclaimerService.init();
}

@NgModule({
  providers: [
    CompetitiveDisclaimerService,
    {
      provide: APP_INITIALIZER,
      useFactory: initServices,
      deps: [CompetitiveDisclaimerService],
      multi: true,
    },
  ],
})
export class DisclaimersModule {}
